import {iomoLayouts as layouts} from '../../layouts/iomoLayouts';

const splashConfigValues = {
	design: 'pole',
	poleHeight: 9,
	poleDiameter: 140,
	poleShape: 'cylindrical',
	numberOfHeads: 8,
	layoutType: 'spiral',
	environment: 'day',
	heightMax: 9,
	heightMin: 5,
	angleMax: 360,
	angleMin: 0,
	heads: [],
	selectedHead: null,

	bracket: '195',
	opticalSystem: 'Comfort',
	colourTemperature: '3000K',
	lightDistribution: '30',
	cap: 'short',
	modifier: 'none',
	housingSize: '195',
	color: '#666',
};

const layout = layouts.spiral.calculate('pole', splashConfigValues);
const branches = layout.branches;
for (let i = 0; i < 8; i++) {
	const head = {
		active: i < branches.length,
		type: 'luminaire', //luminaire
		design: 'pole',
		housingSize: '195',
		opticalSystem: 'Comfort',
		cap: 'short',
		modifier: 'none',
		height: i < branches.length ? branches[i].height : 0,
		angle: i < branches.length ? branches[i].angle : 0,
		roll: 0,
		dimmingLevel: null,
		colourTemperature: '3000K',
		environment: 'day',
		lightDistribution: '30',
		reflectorColour: 'gold',
		accessories: 'None',
		spcDecisions: null,
		collisions: [],
	};
	splashConfigValues.heads.push(head);
}


export {splashConfigValues};
